import React, { useState } from "react";
import FinanceDetailsCard from "./FinanceDetailsCard";
import CustomerDetailsCard from "./CustomerDetailsCard";
import ThreeComponentLayout from "../../../reusable-components/ThreeComponentLayout";
import DatabaseTab from "../../DatabaseTab";
import { DatabaseSections } from "../../../enums/DatabaseEnums";
import { CustomTab } from "../../../Types/DatabaseTabTypes";
import JobTable from "./JobTable";
import CustomerDatabaseService from "../../../services/customerDatabase.service";
import { useLocation } from "react-router-dom";
import TNLoader from "../../../reusable-components/TNLoader";
import ConditionalRender from "../../../reusable-components/ConditionalRender";
import AddCustomerForm from "../AddCustomerForm";
import Form from "../../Form";
import { addCustomerFormSchema } from "../constants";
import NonEditableMask from "../../../reusable-components/NonEditableMask";

const CustomerProfile = () => {
  const location = useLocation();
  const [isMasked, setIsMasked] = useState(location.state?.applyMask || false);
  const pathCustomerId = location.pathname.split("/")[3];
  const prependTabs: CustomTab[] = [
    {
      key: "jobTable",
      label: "Jobs",
      children: (
        <JobTable
          section={DatabaseSections.CUSTOMER}
          sectionId={pathCustomerId}
        />
      ),
    },
  ];
  const { GetSpecificCustomerDetails } = CustomerDatabaseService();
  const { data, isFetching, isRefetching } =
    GetSpecificCustomerDetails(pathCustomerId);

  const [addCustomerFormOpen, setAddCustomerFormOpen] =
    useState<boolean>(false);

  const handleAddCustomerOpen = () => setAddCustomerFormOpen(true);
  const handleAddCustomerClose = () => setAddCustomerFormOpen(false);

  return (
    <>
      <NonEditableMask isMasked={isMasked} />
      <TNLoader isLoading={isFetching || isRefetching} />
      <Form validationSchema={addCustomerFormSchema}>
        {() => (
          <AddCustomerForm
            isOpen={addCustomerFormOpen}
            handleClose={handleAddCustomerClose}
            isEdit={true}
            customerId={pathCustomerId}
            profileView={true}
          />
        )}
      </Form>
      <ConditionalRender visible={!!data}>
        <ThreeComponentLayout
          topLeftWidthPercent={75}
          topLeft={
            <CustomerDetailsCard
              customerDetails={data}
              handleEditFormOpen={handleAddCustomerOpen}
            />
          }
          topRight={
            <FinanceDetailsCard
              revenue={data?.revenue}
              cogs={data?.cogs}
              grossProfit={data?.grossProfit}
              terms={data?.accountTerms}
            />
          }
          bottom={
            <DatabaseTab
              section={DatabaseSections.CUSTOMER}
              sectionId={pathCustomerId}
              prependTabs={prependTabs}
            />
          }
        />
      </ConditionalRender>
    </>
  );
};

export default CustomerProfile;
